import { isPsPOrPhysical, isGatewayOrHybrid } from '@/enums/business-model.enum'
import { isTestAccount } from '@/enums/environment.enum'
import {
  PIX_SERVER_PAYLOAD_ENUM,
  SIMULATOR_PAYLOAD_ENUM,
  PAGARME_PAYLOAD_ENUM
} from './transactional-models.enum'
import { formatCpfCnpj } from '@/utils/formatCpfCnpj.utils'
import { structuredClone } from '@/utils/structured-clone.utils'
class PixConfigManager {
  pix
  pixAffiliations
  constructor (pix, pixAffiliations) {
    this.pix = structuredClone(pix)
    this.pixAffiliations = structuredClone(pixAffiliations)
  }

  isVisible (businessModel, hasCompanyIdInPagarmeSettings, typeAccount) {
    return (
      hasCompanyIdInPagarmeSettings ||
      (isGatewayOrHybrid(businessModel) && !!this.pix?.qr_stone_key) ||
      isTestAccount(typeAccount)
    )
  }

  canEditKeyPix (
    typeAccount,
    dataClientPix,
    hasCompanyIdInPagarmeSettings,
    businessModel
  ) {
    const isDefaultPix =
      !isTestAccount(typeAccount) && dataClientPix && dataClientPix.isEnabled

    const isHavePixPagarme = isDefaultPix && !!hasCompanyIdInPagarmeSettings

    let showPixPagarmeWithPixServe = true
    if (isGatewayOrHybrid(businessModel)) {
      showPixPagarmeWithPixServe = this.pix.gateway === 'pagarme'
    }

    return isHavePixPagarme && showPixPagarmeWithPixServe
  }

  formatTransactionalModel (
    typeAccount,
    businessModel,
    hasCompanyIdInPagarmeSettings
  ) {
    const GatewayOrHybridQrStoneKeyAndPagarme =
      isGatewayOrHybrid(businessModel) &&
      this.pix?.qr_stone_key &&
      !!hasCompanyIdInPagarmeSettings

    const GatewayOrHybridQrStoneKey =
      isGatewayOrHybrid(businessModel) && this.pix?.qr_stone_key

    const isPspAndQrStoneKey =
      isPsPOrPhysical(businessModel) &&
      !!hasCompanyIdInPagarmeSettings &&
      !this.pix?.qr_stone_key

    const isPspAndNotQrStoneKey =
      !!hasCompanyIdInPagarmeSettings && !this.pix?.qr_stone_key

    const transactionalModelOptions = []
    if (isTestAccount(typeAccount))
      transactionalModelOptions.push(SIMULATOR_PAYLOAD_ENUM)

    if (GatewayOrHybridQrStoneKeyAndPagarme) {
      transactionalModelOptions.push(
        PIX_SERVER_PAYLOAD_ENUM,
        PAGARME_PAYLOAD_ENUM
      )
      return transactionalModelOptions
    }

    if (GatewayOrHybridQrStoneKey) {
      transactionalModelOptions.push(PIX_SERVER_PAYLOAD_ENUM)
      return transactionalModelOptions
    }

    if (isPspAndNotQrStoneKey || isPspAndQrStoneKey) {
      transactionalModelOptions.push(PAGARME_PAYLOAD_ENUM)
      return transactionalModelOptions
    }

    return transactionalModelOptions
  }

  getDefaultPixRecipient () {
    const isDefaultRecipient = this.pixAffiliations?.recipients?.find(
      recipient => recipient.is_default_recipient
    )

    return {
      name: isDefaultRecipient?.name ?? '',
      documentNumber: isDefaultRecipient?.document_number
        ? formatCpfCnpj(isDefaultRecipient?.document_number)
        : '',
      recipientId: isDefaultRecipient?.id ?? '',
      isEnabled: this.pixAffiliations?.acquirer?.is_pix_enabled ?? false,
      pixKeys:
        isDefaultRecipient?.pix_keys.length > 0
          ? isDefaultRecipient?.pix_keys[0].id
          : null
    }
  }
}

export default PixConfigManager
